export default __webpack_public_path__ + "static/media/tree_3_anim.6072e629.gif";